import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

interface AnalysisTableHeaderProps {
  onSelectAll: (checked: boolean) => void;
  allSelected: boolean;
  someSelected: boolean;
}

export const AnalysisTableHeader = ({ 
  onSelectAll, 
  allSelected,
  someSelected 
}: AnalysisTableHeaderProps) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-[50px] px-8">
          <Checkbox 
            checked={allSelected}
            onClick={(e) => e.stopPropagation()}
            onCheckedChange={onSelectAll}
            data-state={someSelected ? "indeterminate" : allSelected ? "checked" : "unchecked"}
          />
        </TableHead>
        <TableHead className="w-[65%] sm:min-w-[200px] px-8">URL</TableHead>
        <TableHead className="w-[25%] sm:min-w-[150px] px-8">Palavra-chave</TableHead>
        <TableHead className="w-[10%] text-center px-8">Score</TableHead>
        <TableHead className="hidden sm:table-cell min-w-[150px] px-8">Data</TableHead>
        <TableHead className="hidden sm:table-cell w-[100px] px-8"></TableHead>
        <TableHead className="w-[50px] px-8"></TableHead>
      </TableRow>
    </TableHeader>
  );
};